import { createContext, useContext, useState } from "react";
import { BeatLoader } from "react-spinners";

export const LoadingContext = createContext(false);

export function LoadingProvider({ children }) {
	const [loading, setLoading] = useState(false);
	const value = { loading, setLoading };

	return (
		<LoadingContext.Provider value={value}>
			{loading && (
				<div style={{ zIndex: 1000, position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
					<BeatLoader loading={true} size={24} color="#1e88e5" />
				</div>
			)}
			{children}
		</LoadingContext.Provider>
	)
}

export const useLoading = () => {
	const loading = useContext(LoadingContext);

	const setLoading = (value) => {
		loading.setLoading(value);
	}

	return { loading, setLoading };
}